<template>
<div class="page page_order page_order_detail">
	<div class="list" v-if="orderDetail">
        <div class="item">
            <div class="item_t">
                <div class="item_t_t">
                    <!-- <img :src="orderDetail.orders_ticket.qrcode_url ? orderDetail.orders_ticket.qrcode_url: $publicData.defaultTouxiang" alt="" class="thumb" /> -->
                    <div class="title">{{ orderDetail.order_type == 2 ? '团体票' : '个人票' }}<span class="" v-if="orderDetail.ticket.is_through_ticket">(通票)</span></div>
                </div>
                <div class="status" >{{ orderDetail.pay_status == 2 ? '已支付' : orderDetail.pay_status == 1 ? '支付中' : orderDetail.order_type != 2 ?'待支付' : '已预约'  }}</div>
            </div>
        </div>
        <!-- 订单信息 -->
        <div class="item item_order">
            <div class="title">订单信息</div>
            <div class="order">
                <div class="">订单号：{{ orderDetail.order_sn }}</div>
                <div class="" v-if="orderDetail.pay_order_num">支付订单号：{{ orderDetail.pay_order_num }}</div>
                <div class="">创建时间：{{ orderDetail.created_at }}</div>
                <div class="" v-if="orderDetail.pay_at">付款时间：{{ orderDetail.pay_at }}</div>
                <div class="" v-if="orderDetail.pay_at&&orderDetail.pay_orders">付款方式：{{ orderDetail.pay_orders.pay_name }}</div>
            </div>
        </div>
		<!-- 购票信息 -->
		<div class="item item_order">
            <div class="title">购票信息</div>
			<div class="order">
                <div class="" v-if="orderDetail.smarkpark">园区：{{ orderDetail.smarkpark.title}}</div>
                <div class="" v-if="orderDetail.ticket.venue">展馆：{{ orderDetail.ticket.venue.title }}</div>
				<div class="" v-if="orderDetail.ticket">参观时间：{{ orderDetail.ticket.date_at + ' ' + orderDetail.ticket.beigin_at+'-'+ orderDetail.ticket.end_at}}</div>
				<div class="">是否通票： {{ orderDetail.ticket.is_through_ticket ? '是': '否' }}</div>
            </div>
			<div class="" v-if="orderDetail.orders_ticket">
				<div class="order" v-for="item in orderDetail.orders_ticket" :key="item.id">
					<div class="">参观人员：{{ item.name }}</div>
					<div class="">票价：{{ '¥'+item.price }}</div>
					<div class="">使用状态：{{ item.is_used ? '已用' : '待用' }}</div>
				</div>
			</div>
        </div>
		<!-- 团体信息 -->
		<div class="item item_order" v-if="orderDetail.order_type == 2">
            <div class="title">团体信息</div>
			<div class="" v-if="orderDetail.orders_info">
				<div class="order">
					<div class="">团体名称：{{ orderDetail.orders_info.team_name }}</div>
                    <div class="">团体类型：{{ orderDetail.orders_info.teamtype.name }}</div>
					<div class="">领队姓名：{{ orderDetail.orders_info.name }}</div>
					<div class="">领队电话：{{ orderDetail.orders_info.phone }}</div>
					<div class="">证件号：{{orderDetail.orders_info.id_card}}</div>
					<div class="">团队人数：{{ orderDetail.orders_info.team_num }}</div>
					<div class="">备注：{{ orderDetail.orders_info.remark }}</div>
				</div>
			</div>
        </div>
        <!-- 附加服务 -->
		<div class="item item_order" v-if="orderDetail.orders_services && orderDetail.orders_services.length>0">
            <div class="title">附加服务</div>
			<div class="" >
				<div class="order">
					<div class="" v-for="item in orderDetail.orders_services" :key="item.id">{{ item.name }}</div>
				</div>
			</div>
        </div>
        <!-- 接待员 -->
        <div class="item item_order" v-if="orderDetail.smartpark_order_receper && orderDetail.smartpark_order_receper.length>0">
            <div class="title">接待员</div>
			<div class="" >
				<div class="order">
					<div class="" v-for="item in orderDetail.smartpark_order_receper" :key="item.id">{{ item.smartpark_receper.name }}</div>
				</div>
			</div>
        </div>
        <div class="item item_order" v-if="orderDetail.orderinvoice && orderDetail.orderinvoice.logistics_name&& orderDetail.orderinvoice.logistics_name!=undefined&&orderDetail.orderinvoice.logistics_name!=''">
            <div class="title">发票快递信息</div>
			<div class="" >
				<div class="order">
					<div class="">快递公司：{{ orderDetail.orderinvoice.logistics_name }}</div>
				</div>
                <div class="order">
					<div class="">快递单号：{{ orderDetail.orderinvoice.logistics_code }}</div>
				</div>
			</div>
        </div>
        <div class="actions">
            <div class="action" @click="applyInvoice()" v-if="orderDetail.order_status == 1 && orderDetail.invoice_status == 0">申请发票</div>
            <div class="action" v-if="orderDetail.order_status == 1 && orderDetail.invoice_status == 1">开票中</div>
            <div class="action" v-if="orderDetail.order_status == 1 && orderDetail.invoice_status == 2" @click="showInvoive()">查看发票</div>
        </div>
        <!-- 操作 -->
		<!-- 订单详情里不加支付 -->
        <!-- <div class="actions">
            <div class="action" v-if="orderDetail.pay_status != 2 && orderDetail.order_type != 2">付款</div>
        </div> -->
    </div>
</div>
</template>

<script>
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import PageSearch from "../../../../component/search/Index.vue";
import Vue from "vue";
import Bridge from "../../../../.././vuex/bridge.js";
import { ImagePreview } from 'vant';
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;

export default {
    name: "smart-park",
    data() {
        return {
            publicPath: process.env.BASE_URL,
			orderDetail: null, // 订单详情
			order_sn: this.$route.query.order_sn // 订单号
        };
    },
    components: {
        PageSearch,
    },
    created: function () {
        //根据userAgent判断是否在iOSAndroid客户端中，隐藏原生导航栏
        if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
            var params = {
                data: {
                    // hiddenNavi: true,
                    naviTitle: '订单详情',
                }
            };
            this.$bridge.callhandler("sdjy://navigation/style", params, (data) => {});
            //获取用户信息
            var memberParams = {
                data: {
                },
            };
            this.$bridge.callhandler(
                "sdjy://member/memberInfo",
                memberParams,
                (data) => {
                    if (data.code == 200) {
                        this.token = data.result.token;
						this.getData()
                    } else {
                        this.token = "";
                    }
                }
            );
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler(
                "sdjy://common/refreshPage",
                (data, responseCallback) => {
                    // alert(JSON.stringify(data));
                    responseCallback(data);
                }
            );
        } else {
            this.token = this.$store.getters.token;
			this.getData()
        }
    },
	mounted() {
	},
    methods: {
		// 获取订单详情
		getData(){
			var that = this
			var params = {
				token: that.token,
				order_sn: that.order_sn
			}
			that.$api.smartpark.orderdetail(params).then(res=>{
				if(res.code == 200){
                    var orderDetail = res.result
                    if (orderDetail.pay_orders && orderDetail.pay_orders.pay_name) {
                        if (orderDetail.pay_orders.pay_name.indexOf(',')==0) {
                            var name = orderDetail.pay_orders.pay_name.substring(1,orderDetail.pay_orders.pay_name.length)
                            orderDetail.pay_orders.pay_name = name
                        }
                    }
					that.orderDetail = orderDetail
                    
				}
			})
		},
        applyInvoice() {
            var that = this
            if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                var params = {
					'data': {
						'url': that.$publicData.clientUrl + '/smartpark/order/apply?order_sn='+that.orderDetail.order_sn
						}
					}
				that.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

				})
            } else {
                that.$router.push({
                    path: '/smartpark/order/apply',
                    query: {
                        order_sn: that.orderDetail.order_sn,
                    }
                })
            }
        },
        showInvoive() {
            ImagePreview([this.orderDetail.orderinvoice.dz_thumb]);
        },
		// 支付
		toPay(order){
			var that = this
            if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                var params = {
					'data': {
						'url': that.$publicData.clientUrl + '/smartpark/pay?pay_order_num='+order.pay_order_num+'&price'+order.total_price
						}
					}
				that.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

				})
            } else {
                that.$router.push({
                    path: '/smartpark/pay',
                    query: {
                        pay_order_num: order.pay_order_num,
                        price: order.total_price,
                    }
                })
            }
			
		}
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
